<header class='ra-header'>
    <a href="https://www.allianz.com.tw/zh_TW.html" class="ra-logo" title='回首頁'></a>
</header>
<div class="ra-err-wrapper">
    <div class="ra-404-kv">
        <img src="assets/img/err_404.svg" class='fluid' alt="404 not found">
        <p>找不到頁面</p>
    </div>
    <div class="ra-err-pinktitle txt-idx-pinktitle txt-align-center">您所檢視的網頁已移除或不存在。<br>我們於下方提供首頁與建議網站連結，<br>您可點擊並繼續瀏覽。</div>
    <a href="https://www.allianz.com.tw/zh_TW.html" class="ra-btn ra-idx-btn ra-btn-txt-arrow-tail"><span class='txt-idx-btn-txt' style='margin:0 30px;'>回首頁</span></a>
    <a href='https://product.allianz.com.tw/investment/VAW/product-description' class="ra-btn ra-idx-btn ra-btn-txt-arrow-tail"><span class='txt-idx-btn-txt' style='margin:0 22px;'>商品資訊</span></a>
</div>
<footer class='ra-footer'>
    <div class="ra-ft-in">
        <div class="ra-ft-copyright txt-ft-cp">©Allianz 2021. All Rights Reserved.</div>
        <div class="ra-ft-link">
            <a href="https://www.allianz.com.tw/zh_TW/statement.html" class='txt-ft-a ra-ft-announce' title='網站聲明' target="_blank">網站聲明</a>
            <!-- <a href="javascript:;" class='txt-ft-a ra-ft-cookies' title='Cookies政策' data-open="idModalCookies">Cookies政策</a> -->
            <a href="https://www.allianz.com.tw/zh_TW/about-us/contact-us/contact-us.html" class='txt-ft-a ra-ft-contact' title='聯絡我們' target="_blank">聯絡我們</a>
        </div>
    </div>
</footer>
